// extracted by mini-css-extract-plugin
export var component = "contact-module--component--wDFbT";
export var icon = "contact-module--icon--T3MYn";